export default "__VITE_ASSET__63e1c116__"